import Languages from './languages';

export const substations = [
    {
        id:       1,
        name:     Languages.substation220,
        products: [
            {
                id:          9,
                coordinates: {
                    x: 441,
                    y: -18,
                },
            },
        ],
    },
    {
        id:       2,
        name:     Languages.substation110,
        products: [
            {
                id:                  1,
                labelPositionNumber: 0,
                coordinates:         {
                    x: -557,
                    y: 342,
                },
            },
            {
                id:                  3,
                labelPositionNumber: 2,
                coordinates:         {
                    x: -181,
                    y: 342,
                },
            },
            {
                id:                  6,
                labelPositionNumber: 3,
                coordinates:         {
                    x: 202,
                    y: 342,
                },
            },
            {
                id:                  7,
                labelPositionNumber: 1,
                coordinates:         {
                    x: 562,
                    y: 342,
                },
            },
        ],
    },
    {
        id:       3,
        name:     Languages.substation330,
        products: [
            {
                id:                  23,
                labelPositionNumber: 0,
                coordinates:         {
                    x: -557,
                    y: 342,
                },
            },
            {
                id:                  19,
                labelPositionNumber: 2,
                coordinates:         {
                    x: -181,
                    y: 342,
                },
            },
            {
                id:                  17,
                labelPositionNumber: 3,
                coordinates:         {
                    x: 202,
                    y: 342,
                },
            },
            {
                id:                  25,
                labelPositionNumber: 1,
                coordinates:         {
                    x: 562,
                    y: 342,
                },
            },
        ],
    },
];
